import { notFound } from 'next/navigation';

import type {
  IAccommodationItem,
  IAccommodationOptionType,
  IAccommodationPriceOption,
} from '@/entities/accommodation/types';
import type { IProductOptions } from '@/entities/product/types';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilFetch } from '@/lib/utils';

const apiGetAccommodationRoom = async ({
  idx,
  lng,
}: IProductOptions): Promise<IAccommodationItem> => {
  const response = await utilFetch(lng)(`${NEXT_PUBLIC_API_URL}/api/accommodations/rooms/${idx}`, {
    method: 'GET',
  });
  const result = await response.json();

  // error handling
  if (!result.ok) {
    notFound();
  }

  return filterRoom(result.data);
};

export default apiGetAccommodationRoom;

function filterRoom(response: any): IAccommodationItem {
  return {
    idx: response.idx,
    type: 'ACCOMMODATION',
    title: response.title,
    description: response?.description || '',
    descriptionGoto: response?.descriptionGoto || '',
    included: response?.included || '',
    excluded: response?.excluded || '',
    // standardPeople: response?.standardPeople || 0,
    // addPeople: response?.addPeople || 0,
    standardPeople: 2,
    addPeople: 2,
    checkInTime: response?.checkInTime || '',
    checkOutTime: response?.checkOutTime || '',
    isActive: response.isActive,
    roomOptionTypeList: filterRoomOptionTypeList(response.roomOptionTypes),
    roomPriceList: filterRoomPriceList(response.roomPriceList),
  };
}

function filterRoomOptionTypeList(optionTypeList: any[]): IAccommodationOptionType[] {
  return optionTypeList.map(item => ({
    idx: item.idx,
    title: item.title,
    description: item.description,
    price: item.price,
    type: item.type,
    isActive: item.isActive,
  }));
}

function filterRoomPriceList(priceList: any[]): IAccommodationPriceOption[] {
  return priceList.map(item => ({
    idx: item.idx,
    date: item.date,
    availableCount: item.availableCount,
    price: item.price,
    addPeoplePrice: item.addPeoplePrice,
    isActive: item.isActive,
  }));
}
